/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Wrist_LInputs */

const en_us2_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left wrist or hand`)
};

const pt_br2_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punho ou mão esquerda`)
};

const es_419_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muñeca o mano izquierda`)
};

const pt_pt2_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pulso ou mão esquerda`)
};

const fr_fr2_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poignet ou main gauche`)
};

const de_de2_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linkes Handgelenk oder Hand`)
};

const it_it2_bodymap_region_wrist_l = /** @type {(inputs: Bodymap_Region_Wrist_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polso o mano sinistra`)
};

/**
* | output |
* | --- |
* | "Left wrist or hand" |
*
* @param {Bodymap_Region_Wrist_LInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_wrist_l = /** @type {((inputs?: Bodymap_Region_Wrist_LInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Wrist_LInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_wrist_l(inputs)
	if (locale === "es-419") return es_419_bodymap_region_wrist_l(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_wrist_l(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_wrist_l(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_wrist_l(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_wrist_l(inputs)
	return en_us2_bodymap_region_wrist_l(inputs)
});
export { bodymap_region_wrist_l as "bodymap.region.wrist_l" }